module.exports = __webpack_public_path__ + "images/slv_starkregen.png?57d50473b48b3fa55a2f1cccd390269c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slv_starkregen.png
// module id = wwuY
// module chunks = 0